import gql from "graphql-tag";


export const EDI_MESSAGES = gql`
  query incomingEdiMessages($filter: EdiMessageFilters, $pagination:PaginationInput) {
    incomingEdiMessages(filter: $filter, pagination: $pagination) {
      entries {
        id
        messageType
        orderId
        status
        insertedAt
        updatedAt
      }
      metadata {
        before
        after
        limit      
      }            
    }
  }
`;

export const EDI_MESSAGE = gql`
  query incomingEdiMessage($id:Int!) {
    incomingEdiMessage(id: $id) {
      id
      messageType
      orderId
      status
      filename
      errorMsg
      insertedAt
      updatedAt
    }
  }
`;

export const ORDER_LOG = gql`
  query shippingOrderLog($orderId:ID!) {
    shippingOrderLog(orderId: $orderId) {
      orderId
      eventId
      eventType
      description
      isError
      transient
      errorCode
      occuredAt
    }
  }
`;

export const ON_ORDER_LOG_UPDATED = gql`
  subscription onOrderLogUpdated($orderId:ID!) {
    updatedShippingOrderLog(orderId: $orderId) {
      orderId
      eventId
      eventType
      description
      isError
      transient
      errorCode
      occuredAt      
    }
  }
`;

export const ORDER_ACTIONS_VIEW = gql`
  query shippingOrderActionsView($orderId:ID!) {
    shippingOrderActionsView(orderId: $orderId) {
      orderId
      canStartShipment
      canAddProduct
      canRequestQuote
      canAcceptQuote
      canChangeAddress
      canAssignWarehouse
      canChangeWarehouse
      canReserveStock
      canCancelOrder
      canVoidShipment  
      canScheduleShipment
      canUnscheduleShipment    
    }
  }
`;

export const ON_ORDER_ACTIONS_VIEW_UPDATED = gql`
  subscription onUpdatedShippingOrderActionsView($orderId:ID!) {
    updatedShippingOrderActionsView(orderId: $orderId) {
      orderId
      canStartShipment
      canAddProduct
      canRequestQuote
      canAcceptQuote
      canChangeAddress
      canAssignWarehouse
      canChangeWarehouse
      canReserveStock
      canCancelOrder
      canVoidShipment
      canScheduleShipment
      canUnscheduleShipment          
    }
  }
`;

export const DISTRIBUTION = gql`
  query distribution($kind:String) {
    distribution(kind: $kind) {
      kind
      code
      name
      warehouseId
      warehouseInfo {
        system
      }
      shopId
    }
  }
`;

export const ON_DISTRIBUTION_UPDATED = gql`
  subscription onDistributionUpdated {
    updatedDistribution {
      kind
      code
    }
  }
`

export const DELIVERY_MESSAGE = gql`
  query shippingDeliveryInstructions($orderId:ID!) {
    shippingDeliveryInstructions(orderId:$orderId) {
      orderId
      message
    }
  }
`;

export const ON_DELIVERY_MESSAGE_UPDATE = gql`
  subscription onDeliveryMessageUpdated($orderId:ID!) {
    updatedDeliveryMessage(orderId:$orderId) {
      orderId
    }
  }
`;

export const LIST_ORDERS_FOR_ACCOUNT = gql`
  query shippingOrdersForAccount($filter:ShippingOrderFilters!, $pagination:PaginationInput) {
    shippingOrders(filter: $filter, pagination: $pagination) {
      entries {
        orderId
        accountId
        salesOrderId
        nrPackages
        pickupDate
        pickupOverdue
        scheduled
        fulfillmentStatus
        hold
        type
        gift
        deliveryAddress {
          name
        }
      }
      metadata {
        before
        after
        limit      
      }      
    }
  }
`;

export const LIST_ORDERS = gql`
  query shippingOrders($filter:ShippingOrderFilters, $pagination:PaginationInput) {
    shippingOrders(filter: $filter, pagination: $pagination) {
      entries {
        orderId
        salesOrderId
        accountId
        jurisdictionId
        warehouseId
        nrPackages
        fulfillmentStatus
        prepDate
        pickupDate
        scheduled
        receivedAt
        hold
        type
        gift
        pickupOverdue
        deliveryAddress {
          name
          addressCountryCode
          addressStateProvince
          addressCity
        }
        originalOrderId
        replacedPackageIds {
          packageId
          replacementOrderId
          reason
        }
        hasReplacement
        externalSource
        externalSourceOrderId
      }
      metadata {
        before
        after
        limit      
      }
    }    
  }
`;

export const GET_ORDER_DELIVERY_ADDRESS_FOR_EDIT = gql`
  query shippingOrderDeliveryAddress($orderId:ID!) {
    shippingOrder(orderId:$orderId) {
      orderId
      deliveryAddress {
        type        
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryCode
      }
    },
    countriesAvailableForShippingOrder(orderId:$orderId) {
      code
      name
    }
  }
`;

export const SHIPMENT_SCHEDULE_WITH_RECOMMENDATION_AND_HOLIDAYS = gql`
  query shipmentScheduleWithRecommendation($orderId:ID!) {
    shipmentLoadingSchedule(orderId:$orderId) {
      orderId
      scheduled
      prepDate
      pickupDate
    }
    shipmentLoadingRecommendation(orderId:$orderId) {
      orderId
      prepDate
      pickupDate
    }
    unavailableShippingDatesForOrder(orderId:$orderId) {
      date
      event
    }
  }
`;

export const GET_ORDER = gql`
  query shippingOrder($orderId:ID!) {
    shippingOrder(orderId:$orderId) {
      orderId
      extOrderId
      salesOrderId
      refSalesOrderId
      accountId
      jurisdictionId
      warehouseId
      courierId
      courierService
      courierDeliveryInstructions
      nrPackages
      fulfillmentStatus
      quoteStatus
      stockStatus
      stockReservationId
      receivedAt
      prepDate
      pickupDate
      scheduled
      pickupOverdue
      inCheckout
      hold
      type
      gift
      deliveryAddress {
        type        
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryCode
        addressCountryName
      }
      packages {
        packageId
        dimensions
        weight
        trackingNr
        inventory {
          title
          sku
        }
        packaging {
          title
          sku
        }
      }
      originalOrderId
      replacedPackageIds {
        packageId
        replacementOrderId
        reason
      }
      hasReplacement
      externalSource
      externalSourceOrderId
      notes
      autoProcessingStatus
      transportMethod
    }
  }
`;

export const ON_ORDER_UPDATED = gql`
  subscription onOrderUpdated($orderId: ID!) {
    updatedShippingOrder(orderId: $orderId) {
      orderId
    }
  }
`;

export const ON_QUOTE_UPDATED = gql`
  subscription onQuoteUpdated($orderId: ID!) {
    updatedShippingQuote(orderId: $orderId) {
      orderId
    }
  }
`;

export const COURIER_SERVICES_FOR_ORDER = gql`
  query availableCourierServicesForOrder($orderId:ID!) {
    availableCourierServicesForOrder(orderId:$orderId) {
      service
      name
      description
      default
    }
  }
`;

export const LIST_TERRITORIES = gql`
 query territories {
    territories {
      id
      name
    }
 }
`;

export const LIST_COUNTRIES = gql`
  { countries {
    code
    name
  }}
`;

export const SHIPPING_ADDRESSES = gql`
  query shippingAddresses($accountId:ID!) {
    shippingAddresses(accountId:$accountId) {
      accountId
      addressId
      type
      label
      name
      addressAddressLine1
      addressAddressLine2
      addressCity
      addressStateProvince
      addressPostcode
      addressCountryCode
      addressCountryName
      verificationStatus
    }
  }
`;

export const ON_SHIPPING_ADDRESSES_UPDATED = gql`
  subscription onShippingAddressesUpdated($accountId: ID!) {
    updatedShippingAddresses(accountId: $accountId) {
      accountId
    }
  }
`;


export const PREFERRED_COURIER_SERVICES = gql`
  query preferredCourierServices{
    preferredCourierServices {
      accountId
      courierId
      countryCode
      service
    }
  }
`;
